import React, { Component } from "react";
import VisitorHeader from "./visitorHeader";
import VisitorLanguage from "./visitorLanguage";
import playButtonIcon from "../../assets/photos/play.png";
import downloadButtonIcon from "../../assets/photos/download.png";
import eyeButtonIcon from "../../assets/photos/eye.png";
import { connect } from "react-redux";
import axios from "axios";
import App from "../../App";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";

class Visitor extends Component {
  // Visitor Component to be shown at /visitor url
  constructor(props) {
    super(props);
    this.state = {
      doneLanguagePart: false,
      languageSelected: "",
      pdfDownloadLoading: false,
      pdfData: null,
      voiceData: null,
      voiceDownloading: false,
    };
    this.source = axios.CancelToken.source();
  }

  toastMessagePopUp = (message) => {
    // toast error message popup function
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  selectLanguage = (language) => {
    // gets called from visitorLanguage.jsx as props and sets the langage to state and calls the api to download pdf
    this.setState(
      {
        languageSelected: language,
        doneLanguagePart: true,
        pdfDownloadLoading: true,
        PDFfileName: "",
      },
      () => {
        this.downloadPDFApi();
      }
    );
  };

  goBackToSelectLanguage = () => {
    // back button on visitor page which guides back to select language by changing the state
    this.setState({
      doneLanguagePart: false,
    });
  };

  onClickPlay = () => {
    // Gets called when user presses the play button which opens the audio file in new tab
    const found = this.props.museum.museum_multimedia.find(
      // finds the audio for selected language if exists
      (element) =>
        element.lang === this.state.languageSelected &&
        element.file_type === "Audio"
    );

    if (found) {
      // if audio found for selected language
      let url =
        App.baseUrl + "api/museum-multimedia/download/" + found.filename;

      var redirectAccountUrl = url;

      const http = new XMLHttpRequest();

      // Opens an XMLHttpPeruest as we need access_token to open the audio in new tab

      http.open("GET", redirectAccountUrl, true);
      http.withCredentials = false;
      http.setRequestHeader("Accept", "application/json, text/plain, */*");
      http.setRequestHeader(
        "Authorization",
        "Bearer " + this.props.access_token + ""
      );
      http.send();
      window.open(redirectAccountUrl);
    } else {
      // audio does not exists
      this.toastMessagePopUp(
        "Audio for " + this.state.languageSelected + " not available"
      );
    }
  };

  onClickDownload = () => {
    // calls when user presses the download button

    if (this.state.pdfData) {
      // checks if the pdf is downloaded and store in the local state or not
      // creates a blob file and an <a> tag and triggers it to download
      const file = new Blob([this.state.pdfData], {
        type: this.state.pdfData.type,
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = this.state.PDFfileName;
      document.body.append(link);
      link.click();
      link.remove();
    } else {
      // file does not exists
      this.toastMessagePopUp(
        "PDF for " + this.state.languageSelected + " not available"
      );
    }
  };

  onClickView = () => {
    // calls when user peresses the view(eye icon) button
    const found = this.props.museum.museum_multimedia.find(
      // finds the audio for selected language if exists
      (element) =>
        element.lang === this.state.languageSelected &&
        element.file_type === "PDF"
    );

    if (found) {
      // if file exists for the selected language
      let url =
        App.baseUrl + "api/museum-multimedia/download/" + found.filename;

      var redirectAccountUrl = url;

      // Opens an XMLHttpPeruest as we need access_token to open the audio in new tab

      const http = new XMLHttpRequest();

      http.open("GET", redirectAccountUrl, true);
      http.withCredentials = false;
      http.setRequestHeader("Accept", "application/json, text/plain, */*");
      http.setRequestHeader(
        "Authorization",
        "Bearer " + this.props.access_token + ""
      );
      http.send();
      window.open(redirectAccountUrl);
    } else {
      // file does not exists
      this.toastMessagePopUp(
        "PDF for " + this.state.languageSelected + " not available"
      );
    }
  };

  downloadPDFApi = () => {
// api to download the file and store it in state
    const found = this.props.museum.museum_multimedia.find(
      (element) =>
        element.lang === this.state.languageSelected &&
        element.file_type === "PDF"
    );
    if (found) {
      // api calls only if the file exists
      let url =
        App.baseUrl + "api/museum-multimedia/download/" + found.filename;
      axios
        .get(
          url,
          { responseType: "blob" },
          {
            cancelToken: this.source.token,
          }
        )
        .then((response) => {
          // forces the response to 'blob' and stores the response to state
          this.setState({
            pdfData: response.data,
            pdfDownloadLoading: false,
            PDFfileName: found.filename,
          });
        })
        .catch((error) => {
          if (error.response.status === 404) {
            // file not found error
            this.toastMessagePopUp(
              // file not available error
              "PDF for " + this.state.languageSelected + " not available"
            );
          } else {
            this.toastMessagePopUp("something went wrong");
          }
          // stop the loader from state pdfDownloadingLoading
          this.setState({ pdfDownloadLoading: false });
        });
    } else {
      // stop the loader state pdfDownloadingLoading
      this.setState({ pdfDownloadLoading: false });
    }
  };

  componentWillUnmount() {
    // cleanup function
    this.source.cancel();
  }

  render() {
    // console.log(this.props.museum);
    let defaultComponetValue = (
      <div className="visitorlanguage-page-layout">
        <div>
          <span className="visitorlanguage-checkbox-active">Proceed</span>
          <hr className="visitor-tag-line" />
        </div>
        <div>
          <span className="visitorlanguage-checkbox-active">Document</span>
          <button
            disabled={this.state.pdfDownloadLoading}
            onClick={this.onClickDownload}
            id="visitor-data-button"
          >
            {this.state.pdfDownloadLoading ? (
              <Spinner animation="border" id="visitor-loading-spinner" />
            ) : (
              <img
                id="visitor-icon-align"
                src={downloadButtonIcon}
                width="20px"
                height="20px"
              />
            )}
          </button>
          <button onClick={this.onClickView} id="visitor-data-button">
            <img
              id="visitor-icon-align"
              src={eyeButtonIcon}
              width="20px"
              height="20px"
            />
          </button>
          <hr className="visitor-tag-line" />
        </div>
        <div>
          <span className="visitorlanguage-checkbox-active">Audio</span>
          <button onClick={this.onClickPlay} id="visitor-data-button">
            <img
              id="visitor-icon-align"
              src={playButtonIcon}
              width="20px"
              height="20px"
            />
          </button>
          <hr className="visitor-tag-line" />
        </div>
        <button
          onClick={() => this.goBackToSelectLanguage()}
          id="visitor-databack-button"
        >
          Back
        </button>
      </div>
    );

    return (
      <div>
        <VisitorHeader />
        {!this.state.doneLanguagePart ? (
          <VisitorLanguage
            language={this.state.languageSelected}
            selectLanguage={this.selectLanguage}
          />
        ) : (
          defaultComponetValue
        )}
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    museum: state.museumData.museumData,
    access_token: state.AccessTokenData.accessToken,
  };
};

export default connect(mapStateToProps, null)(Visitor);
